import { render, staticRenderFns } from "./OrderStatusEditDialog.vue?vue&type=template&id=02b65bcc&scoped=true"
import script from "./OrderStatusEditDialog.vue?vue&type=script&lang=js"
export * from "./OrderStatusEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b65bcc",
  null
  
)

export default component.exports